export const SCHOOL_TYPE_LEVELS: Record<string, string[]> = {
    '101': ['AK'],
    '102': ['AK'],
    '111': ['AK'],
    '112': ['AK'],
    '113': ['AK'],
    '114': ['AK'],
    '115': ['AK'],
    '116': ['AK'],
    '117': ['AK'],
    '118': ['AK'],
    '119': ['AK'],
    '121': ['YK'],
    '122': ['YK'],
    '123': ['YK'],
    '124': ['YK'],
    '125': ['YK'],
    '126': ['YK'],
    '127': ['YK'],
    '128': ['YK'],
    '129': ['YK'],
    '131': ['LK'],
    '132': ['LK'],
    '133': ['LK'],
    '134': ['LK'],
    '135': ['LK'],
    '136': ['LK'],
    '137': ['LK'],
    '138': ['LK'],
    '139': ['LK'],
    '140': ['AK', 'YK', 'LK'],
    '141': ['AK'],
    '142': ['AK', 'YK', 'LK'],
    '143': ['YK'],
    '144': ['LK'],
    '145': ['AK'],
    '146': ['YK'],
    '147': ['LK'],
    '200': ['LK'],
    '201': ['AK'],
    '202': ['YK', 'LK'],
    '203': ['AK'],
    '204': ['YK', 'LK'],
    '205': ['AK'],
    '206': ['YK'],
    '207': ['AK'],
    '208': ['YK'],
    '210': ['LK'],
    '211': ['LK'],
    '220': ['LK'],
    '230': ['LK'],
    '231': ['LK'],
    '240': ['LK'],
    '241': ['LK'],
    '250': ['AK', 'YK', 'LK'],
    '996': ['LK'],
    '997': ['AK', 'YK', 'LK'],
    '998': ['AK', 'YK', 'LK'],
    '999': ['AK', 'YK', 'LK'],
};

export const SCHOOL_TYPE_DESCRIPTIONS: Record<string, string> = {
    '101': 'Päiväkoti',
    '102': 'Päiväkoti, esiopetus',
    '111': 'Alakoulu',
    '112': 'Yhtenäiskoulu, alakoulu',
    '113': 'Yhteiskoulu, alakoulu',
    '114': 'Normaalikoulu, alakoulu',
    '115': 'Erityiskoulu, alakoulu',
    '116': 'Muu koulu, alakoulu',
    '117': 'Steinerkoulu, alakoulu',
    '118': 'Alakoulu, esiopetus',
    '119': 'Oppilaitos, alakoulu',
    '121': 'Yläkoulu',
    '122': 'Yhtenäiskoulu, yläkoulu',
    '123': 'Yhteiskoulu, yläkoulu',
    '124': 'Normaalikoulu, yläkoulu',
    '125': 'Erityiskoulu, yläkoulu',
    '126': 'Muu koulu, yläkoulu',
    '127': 'Steinerkoulu, yläkoulu',
    '128': 'Aikuislukio, yläkoulu',
    '129': 'Oppilaitos, yläkoulu',
    '131': 'Lukio',
    '132': 'Yhtenäiskoulu, lukio',
    '133': 'Yhteiskoulu, lukio',
    '134': 'Normaalikoulu, lukio',
    '135': 'Erityiskoulu, lukio',
    '136': 'Muu koulu, lukio',
    '137': 'Steinerkoulu, lukio',
    '138': 'Aikuislukio',
    '139': 'Oppilaitos, lukio',
    '140': 'Muut',
    '141': 'Ruotsinkieliset, alakoulu',
    '142': 'Ruotsinkieliset, yhtenäiskoulu',
    '143': 'Ruotsinkieliset, yläkoulu',
    '144': 'Ruotsinkieliset, lukio',
    '145': 'Ruotsinkieliset, yhtenäiskoulu, alakoulu',
    '146': 'Ruotsinkieliset, yhtenäiskoulu, yläkoulu',
    '147': 'Ruotsinkieliset, yhtenäiskoulu, lukio',
    '200': 'Ammattikorkeakoulu hallinto',
    '201': 'Opettajankoulutuslaitos, alakoulu',
    '202': 'Opettajankoulutuslaitos, yläkoulu/lukio',
    '203': 'Opettajankoulutuslaitos, alakoulu (kirjasto)',
    '204': 'Opettajankoulutuslaitos, yläkoulu/lukio (kirjasto)',
    '205': 'Normaalikoulu, alakoulu harjoittelukoulu',
    '206': 'Normaalikoulu, yläkoulu harjoittelukoulu',
    '207': 'Normaalikoulu, alakoulu (kirjasto)',
    '208': 'Normaalikoulu, yläkoulu (kirjasto)',
    '210': '(Ammatti)oppilaitos',
    '211': 'Ammatillista aikuiskoulutusta tarjoava taho',
    '220': 'Ammattikorkeakoulu',
    '230': 'Yliopisto',
    '231': 'Yliopiston / korkeakoulun kielikeskus',
    '240': 'Kansalais- / työväenopisto',
    '241': 'Kansan- ja kristilliset opistot',
    '250': 'Oppimateriaalikeskus',
    '996': 'Yrityskoulu, ei laskutusta',
    '997': 'Suomi',
    '998': 'Ulkomaiset koulut',
    '999': 'Yrityskoulut',
};

export const getSchoolTypeDescription = (type: string): string =>
    SCHOOL_TYPE_DESCRIPTIONS[type] || `Koulutyyppi ${type}`;
